module.exports = __webpack_public_path__ + "static/img/mickey.cd44d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/collage/mickey.jpg
// module id = fBso
// module chunks = 1